import { render, staticRenderFns } from "./PopupUpload.vue?vue&type=template&id=49288ba4&scoped=true"
import script from "./PopupUpload.vue?vue&type=script&lang=js"
export * from "./PopupUpload.vue?vue&type=script&lang=js"
import style0 from "./PopupUpload.vue?vue&type=style&index=0&id=49288ba4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49288ba4",
  null
  
)

export default component.exports